import { Entities, Periods } from 'cio/utils/metrics/common';
import { TrackedLinkMetric } from 'cio/utils/metrics/models/tracked-link-metric';
import { TimeRange } from 'cio/utils/time';

export function deserialize(
  data: any,
  entityType: Entities,
  entityId: number | string,
  period: Periods | null,
  resolution: Periods | null,
  range: TimeRange | null,
  actionType: string | null,
  meta?: { environmentId?: number | string; campaignId?: number | string; version?: number },
): null | TrackedLinkMetric {
  let useV2 = meta?.version === 2;
  let { tracked_link_metric: trackedLinkMetric } = data;

  if (!trackedLinkMetric) {
    return null;
  }

  let trackedLinkMetricStats = useV2 ? trackedLinkMetric.values : trackedLinkMetric.tracked_link_metric_stats;

  return new TrackedLinkMetric({
    entityId,
    entityType,
    period,
    resolution,
    range,
    actionType: actionType ?? 'all',
    values: trackedLinkMetricStats ?? [],
    meta,
  });
}
